import { useCallback } from 'react';
import type { SearchParameters } from 'app/domain';
import useSearchFactoryAdapter from '../search/useSearchFactoryAdapter';
import { searchQueryAdapter } from './searchQueryAdapter';

type ToSearchQuery = (
  searchParameters: SearchParameters,
  previousSearchParameters?: SearchParameters
) => Record<string, string>;

// searchQueryAdapter bound to the visitor's search factory, so callers ask only
// for a query and never supply what the url signals need to decide it.
const useSearchQueryAdapter = (): ToSearchQuery => {
  const searchFactory = useSearchFactoryAdapter();

  return useCallback(
    (searchParameters, previousSearchParameters) =>
      searchQueryAdapter(
        searchParameters,
        searchFactory,
        previousSearchParameters
      ),
    [searchFactory]
  );
};

export default useSearchQueryAdapter;
